<template>
  <div class="box">
    <dv-loading class="loadingCss" v-if="loading">Loading...</dv-loading>
    <div
      v-show="!loading"
      class="listCss"
      v-for="(item, index) in item.scaleOptions"
      :key="item.id"
      :class="{ activeCss: activeVar == index }"
      @click="activeFun(item, index)"
    >
      <img
        v-if="item.fileId"
        @load="imgOver"
        :src="item.fileId"
        alt
        class="photo"
      />
    </div>
  </div>
</template>

<script>
import { letterFize, letterNum } from '@/utils/index.js';
import drawMixin from '@/utils/drawMixin.js';
export default {
  name: 'fiveSelectOne',
  mixins: [drawMixin],
  components: {},
  props: {
    echo: {
      default: null
    },
    item: {
      default: () => {}
    }
  },
  data() {
    return {
      isShow: true,
      activeVar: null,
      fizeWord: null,
      count: 0,
      loading: true
    };
  },
  created() {},
  mounted() {},
  watch: {
    echo: {
      handler(newVal) {
        if (newVal) {
          this.activeVar = letterNum(newVal);
          this.fizeWord = letterFize(this.activeVar);
          this.$emit('nextTopic', this.fizeWord);
        }
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    activeFun(item, index) {
      // item 为被选中的元素体
      this.activeVar = index;
      this.fizeWord = letterFize(this.activeVar);
      this.$emit('nextTopic', this.fizeWord);
    },
    imgOver() {
      this.count++;
      if (this.count == this.item.scaleOptions.length) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.listCss {
  text-align: center;
  margin: 10px;
  font-size: 0;
}
// 选中时的样式 (继承上方默认样式)
.activeCss {
  opacity: 1;
  background: red;
  border-radius: 37px;
}
.photo {
  opacity: 0.9;
  width: 100%;
  height: 100%;
}
</style>